import { StylesConfig } from 'react-select';

const SelectStyles: StylesConfig = {
  control: (styles, { isDisabled }) => ({
    ...styles,
    background: isDisabled ? '#0b1a28' : 'var(--color-background-dark)',
    border: '1px solid #ffffff26;',
    borderRadius: '4px',
    outline: 'none',
    boxShadow: 'none',
    cursor: 'pointer',
    minHeight: '38px !important',
    marginBottom: '18px',
    textAlign: 'left',
    ':hover': {
      ...styles[':hover'],
      borderColor: '#ffffff26',
    },

    '@media only screen and (max-width: 1366px)': {
      minHeight: '36px !important',
    },
    '@media only screen and (max-width: 767px)': {
      marginBottom: '16px',
    },
  }),
  option: (styles, { isFocused, isSelected, data }: any) => {
    return {
      ...styles,
      cursor: 'pointer',
      fontSize: '14px',
      background: isFocused ? '#0b1a28' : isSelected ? '#0b1a28' : '#0b1a28',
      whiteSpace: 'pre',
      zIndex: 9999,
      color: isFocused ? '#e0e0e0' : isSelected ? '#e0e0e0' : '#e0e0e0',
      textAlign: 'left',
      ':hover span': {
        ...styles[':hover'],
        color: '#000',
      },
      ':hover .logo': {
        ...styles[':hover'],
        filter: 'brightness(0) invert(0)',
      },
      ':hover': {
        ...styles[':hover'],
        backgroundColor: '#FF53FF',
        color: '#000',
      },
      '@media only screen and (max-width: 1366px)': {
        fontSize: '13px',
      },
    };
  },
  multiValue: (styles, { isDisabled }) => ({
    display: 'inline-flex',
    background: isDisabled ? '#E1E1E1' : 'var(--color-text-highlight)',
    borderRadius: '4px',
    paddingLeft: '10px',
    margin: '2px',
  }),
  multiValueLabel: (styles) => ({
    fontSize: '14px',
    color: '#000',
    fontWeight: '500',
    marginTop: '3px',
    '@media only screen and (max-width: 1366px)': {
      fontSize: '13px',
    },
  }),
  multiValueRemove: (styles) => ({
    padding: '0 5px',
    color: '#000',
    filter: 'brightness(0)',
    marginTop: '3px',
  }),
  input: (styles) => ({
    ...styles,
    padding: '0',
    margin: '0',
    boxShadow: 'none',
    outline: 'none',
    color: '#FFF',
  }),
  placeholder: (styles) => ({
    ...styles,
    color: '#fff',
    opacity: '.5',
    fontSize: '14px',
    '@media only screen and (max-width: 1366px)': {
      fontSize: '13px',
    },
  }),
  singleValue: (styles, { data }: any) => ({
    ...styles,
    color: '#fff',
    fontSize: '12px',
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    padding: '0 6px',
    color: '#e0e0e0',
  }),
  clearIndicator: (styles) => ({
    display: 'none',
  }),
  indicatorSeparator: (styles) => ({
    display: 'none',
  }),

  menu: (styles) => {
    return {
      ...styles,
      zIndex: 999,
      background: 'var(--purple-500)',
      border: '2px solid #232D3A',
      top: '31px',
    };
  },
  menuList: (styles) => {
    return {
      ...styles,
      maxHeight: 150,
      overflowX: 'hidden',
    };
  },
};

export default SelectStyles;
